module.exports = __webpack_public_path__ + "img/booking.dc8e1e62.png";